import { Box, styled } from '@mui/material';

export const BundleFooterBannerHighlightImageContainer = styled(Box)`
  width: 176px;
  height: 100px;
  position: relative;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    display: none;
  }
`;

export const BundleFooterBannerMultipleImageStyle = styled(Box)`
  width: 176px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 49px 49px;
  gap: 1.5px;
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  overflow: hidden;
`;
